// src/App.js
import "bootstrap/dist/css/bootstrap.min.css";
import { AuthProvider, useAuth } from "./AuthContext";
import AdminStudents from "./AdminStudents";
import LoginPage from "./LoginPage";

function AppContent() {
  const { user, authLoading, logout } = useAuth();

  if (authLoading) {
    return <div className="container p-4">Lade...</div>;
  }

  if (!user) {
    // Nicht eingeloggt → Login-Seite
    return <LoginPage />;
  }

  // Eingeloggt → Admin-Oberfläche mit Logout
  return (
    <>
      <nav className="navbar navbar-light bg-light mb-3">
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1">zeb.bs</span>
          <div>
            <span className="me-3">
              Eingeloggt als {user.email}
            </span>
            <button className="btn btn-outline-secondary btn-sm" onClick={logout}>
              Logout
            </button>
          </div>
        </div>
      </nav>
      <AdminStudents />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
